module.exports = __webpack_public_path__ + "static/media/logo.80bd65c1.png";